'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAppAuthSelector = undefined;

var _AuthType = require('pricing-pages-unified-ui/constants/AuthType');

var isAppAuthSelector = exports.isAppAuthSelector = function isAppAuthSelector(state) {
  return state.config.authType === _AuthType.APP;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ConfigSelectors.js
// module id = 147
// module chunks = 3 4 5